import React, {useEffect, useState} from 'react';
import {InitialValueType} from './initial-value';

const TextFieldInitialValue = ({value, onChange, radioBoxName}) => {

  const [model, setModel] = useState(null);

  const setModelAndNotify = newModel => {
    setModel(newModel);
    onChange(newModel);
  }

  useEffect(() => {
    if (!value.type) {
      setModelAndNotify({
        ...value,
        type: InitialValueType.TEXT,
        text: value.text || ''
      });
    } else {
      setModel(value);
    }
  }, [ value ]);

  if (!model) {
    return <div />
  } else {
    return <div>
      <div className="form-check">
        <input type="radio"
               name={radioBoxName}
               id={radioBoxName + 'InitialValueText'}
               className="form-check-input"
               value={InitialValueType.TEXT}
               checked={model.type === InitialValueType.TEXT}
               onChange={e => setModelAndNotify({...model, type: e.target.value})}/>
        <label className="form-check-label" htmlFor={radioBoxName + 'InitialValueText'}>
          Text value
        </label>
      </div>
      {model.type === InitialValueType.TEXT &&
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <div className="mb-3">
                <textarea className="form-control"
                          placeholder="Enter an initial value"
                          value={model.text || ''}
                          onChange={e => setModelAndNotify({...model, text: e.target.value})}/>
          </div>
        </div>
      </div>
      }
      <div className="form-check">
        <input type="radio"
               name={radioBoxName}
               id={radioBoxName + 'InitialValueShopifyCustomerFirstName'}
               className="form-check-input"
               value={InitialValueType.SHOPIFY_CUSTOMER_FIRST_NAME}
               checked={model.type === InitialValueType.SHOPIFY_CUSTOMER_FIRST_NAME}
               onChange={e => setModelAndNotify({...model, type: e.target.value})}/>
        <label className="form-check-label" htmlFor={radioBoxName + 'InitialValueShopifyCustomerFirstName'}>
          Customer&apos;s first name (only available if your customer is logged in)
        </label>
      </div>
      <div className="form-check">
        <input type="radio" name="initialValueType"
               id={radioBoxName + 'InitialValueShopifyCustomerLastName'}
               className="form-check-input"
               value={InitialValueType.SHOPIFY_CUSTOMER_LAST_NAME}
               checked={model.type === InitialValueType.SHOPIFY_CUSTOMER_LAST_NAME}
               onChange={e => setModelAndNotify({...model, type: e.target.value})}/>
        <label label="form-check-label" htmlFor={radioBoxName + 'InitialValueShopifyCustomerLastName'}>
          Customer&apos;s last name (only available if your customer is logged in)
        </label>
      </div>
      <div className="form-check">
        <input type="radio"
               name={radioBoxName}
               id={radioBoxName + 'InitialValueShopifyCustomerFullName'}
               className="form-check-input"
               value={InitialValueType.SHOPIFY_CUSTOMER_FULL_NAME}
               checked={model.type === InitialValueType.SHOPIFY_CUSTOMER_FULL_NAME}
               onChange={e => setModelAndNotify({...model, type: e.target.value})}/>
        <label className="form-check-label" htmlFor={radioBoxName + 'InitialValueShopifyCustomerFullName'}>
          Customer&apos;s full name (only available if your customer is logged in)
        </label>
      </div>
      <div className="form-check">
        <input type="radio"
               name={radioBoxName}
               id={radioBoxName + 'InitialValueShopifyCustomerPhoneNumber'}
               className="form-check-input"
               value={InitialValueType.SHOPIFY_CUSTOMER_PHONE_NUMBER}
               checked={model.type === InitialValueType.SHOPIFY_CUSTOMER_PHONE_NUMBER}
               onChange={e => setModelAndNotify({...model, type: e.target.value})}/>
        <label className="form-check-label" htmlFor={radioBoxName + 'InitialValueShopifyCustomerPhoneNumber'}>
          Customer&apos;s phone number (only available if your customer is logged in)
        </label>
      </div>
      <div className="form-check">
        <input type="radio"
               name={radioBoxName}
               id={radioBoxName + 'InitialValueJavascript'}
               className="form-check-input"
               value={InitialValueType.JAVASCRIPT}
               checked={model.type === 'JAVASCRIPT'}
               onChange={e => setModelAndNotify({...model, type: e.target.value})}/>
        <label className="form-check-label" htmlFor={radioBoxName + 'InitialValueJavascript'}>
          Use Javascript
        </label>
      </div>
      {model.type === InitialValueType.JAVASCRIPT &&
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <div className="mb-3">
              <textarea className="form-control" style={{minHeight: '8em'}}
                        placeholder="var otherField = $('#other-field'); otherField.val();"
                        value={model.javascript || ''}
                        onChange={e => setModelAndNotify({...model, javascript: e.target.value})}/>
          </div>
        </div>
      </div>
      }
    </div>;
  }

};

export default TextFieldInitialValue;
